import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  OnDestroy,
} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-rapoarte-conta-incasari-search',
  templateUrl: './rapoarte-conta-incasari-search.component.html',
  styleUrls: ['./rapoarte-conta-incasari-search.component.scss']
})
export class RapoarteContaIncasariSearchComponent implements OnInit, OnDestroy {
  @Output() searchResult = new EventEmitter();

  rapoarteIncasariSearchForm;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor() {}

  ngOnInit(): void {
    this.rapoarteIncasariSearchForm = new UntypedFormGroup({
      data_start: new UntypedFormControl(null, Validators.required),
      data_end: new UntypedFormControl(null, Validators.required),
      tip: new UntypedFormControl(null),
    });
  }

  onSubmitted() {
    if (!this.rapoarteIncasariSearchForm.valid) {
      return;
    }
    this.searchResult.emit(this.rapoarteIncasariSearchForm.value);
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.unsubscribe();
  }

  resetSearch() {
    this.rapoarteIncasariSearchForm.reset();
    this.onSubmitted();
  }

  onStartDateChanged(event) {
    if (this.rapoarteIncasariSearchForm) {
      this.rapoarteIncasariSearchForm.controls.data_start.setValue(event);
    }
  }

  onEndDateChanged(event) {
    if (this.rapoarteIncasariSearchForm) {
      this.rapoarteIncasariSearchForm.controls.data_end.setValue(event);
    }
  }
}
